














































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import getActivityType from '@/common/utils/getActivityType';
import ImageCutUpload from "@/components/common/edit/ImageCutUpload.vue";

@Component({
  components: {
    "image-upload": ImageCutUpload
  }
})
export default class ActivityMainImageEdit extends Vue {
  @Getter("groupSliderList") groupImageList!: Array<string>;
  @Getter("section") section!: any;

  @Action("changeGroupImageList") changeGroupImageList!: Function;
  @Action("changeViewBackground") changeViewBackground!: Function;

  getActivityType: Function = getActivityType;
  currentIndex: number = 0;

  get notEmptyList(): Array<string> {
    return this.groupImageList.filter((value, index) => {
      return value || index === 0;
    });
  }

  get trueEmptyList(): Array<string> {
    return this.notEmptyList.filter(value => {
      return value;
    });
  }

  get scrollImageList(): Array<string> {
    if (this.trueEmptyList.length === 1) {
      return [];
    } else if (
      this.trueEmptyList.length === 2 ||
      this.trueEmptyList.length === 3
    ) {
      return this.trueEmptyList.concat(this.trueEmptyList);
    }
    return this.trueEmptyList;
  }

  handleDeletePrizeImage(index: number): void {
    if (index === 0) {
      this.changeViewBackground("");
    } else {
      const payload = {
        index: index - 1,
        value: ""
      };
      console.log(payload,'payload');
      
      this.changeGroupImageList(payload);
    }
    this.currentIndex = 0;
  }

  handleChangePrizeImage(imgUrl: string, index: number): void {
    const payload = {
      index,
      value: imgUrl
    };
    this.changeGroupImageList(payload);
  }

  // 恢复图片
  handleRecoverImage() {
    this.changeViewBackground(window.viewBackground);
  }

  mounted() {
    let timer: number;
    const sliderDom = document.querySelector(
      ".activity-slider-content"
    ) as HTMLElement;
    let startPos = 0;
    sliderDom.addEventListener("touchstart", (e: TouchEvent) => {
      if (this.scrollImageList.length > 1) {
        startPos = e.touches[0].clientX;
      }
    });

    sliderDom.addEventListener("touchend", (e: TouchEvent) => {
      if (this.scrollImageList.length > 1) {
        const endPos = e.changedTouches[0].clientX;
        if (endPos - startPos > 10) {
          window.clearInterval(timer);
          this.currentIndex =
            (this.currentIndex - 1 + this.scrollImageList.length) %
            this.scrollImageList.length;
          timer = window.setInterval(this.autoRoll, 3500);
        }
        if (endPos - startPos < -10) {
          window.clearInterval(timer);
          this.currentIndex =
            (this.currentIndex + 1) % this.scrollImageList.length;
          timer = window.setInterval(this.autoRoll, 3500);
        }
      }
    });
    timer = window.setInterval(this.autoRoll, 3500);
  }

  autoRoll() {
    if (this.scrollImageList.length > 1) {
      this.currentIndex = (this.currentIndex + 1) % this.scrollImageList.length;
    }
  }
}
